// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';
import { Notification } from '../../types/Model';
import { actionCreatorsList, RootAction } from '../rootActionCreator';

export interface NotificationsState {
  count: number;
  list: Notification[];
  totalPage?: number;
  unread: number;
  isFetching: boolean;
  error?: Error;
  readAllFetching: boolean;
  readAllError?: Error;
  readFetching: boolean;
  readError?: Error;
  deleteFetching: boolean;
  deleteError?: Error;
  isReseting?: boolean;
  isResetingError?: Error;
}

const {
  getNotificationsActions,
  readAllNotificationsActions,
  readNotificationActions,
  deleteNotificationsActions,
  getResetNotificationsActions,
} = actionCreatorsList;

export const initialState: NotificationsState = {
  list: [],
  unread: 0,
  count: 0,
  isFetching: false,
  readAllFetching: false,
  readFetching: false,
  deleteFetching: false,
  isReseting: false
};

export default function (state = initialState, action: RootAction) {
  switch (action.type) {
    case getType(getNotificationsActions.request): {
      return {
        ...state,
        isFetching: true,
        error: undefined
      };
    }
    case getType(getNotificationsActions.success): {
      const { list, unread, count, totalPage } = action.payload;
      return {
        ...state,
        isFetching: false,
        count,
        list,
        unread,
        totalPage
      };
    }
    case getType(getNotificationsActions.failure): {
      return {
        ...state,
        isFetching: false,
        error: action.payload.error
      };
    }
    case getType(readAllNotificationsActions.request): {
      return {
        ...state,
        readAllFetching: true,
        readAllError: undefined,
      }
    }
    case getType(readAllNotificationsActions.success): {
      return {
        ...state,
        readAllFetching: false
      }
    }
    case getType(readAllNotificationsActions.failure): {
      return {
        ...state,
        readAllFetching: false,
        readAllError: action.payload.error,
      }
    }
    case getType(readNotificationActions.request): {
      return {
        ...state,
        readFetching: true,
        readError: undefined,
      }
    }
    case getType(readNotificationActions.success): {
      const { id } = action.payload;
      return {
        ...state,
        list: state.list.map((notification: Notification) => {
          if (notification.id === id) {
            notification.read = true;
          }
          return notification;
        }),
        unread: state.unread - 1,
        readFetching: false
      }
    }
    case getType(readNotificationActions.failure): {
      return {
        ...state,
        readFetching: false,
        readError: action.payload.error,
      }
    }
    case getType(deleteNotificationsActions.request): {
      return {
        ...state,
        deleteFetching: true,
        deleteError: undefined,
      }
    }
    case getType(deleteNotificationsActions.success): {
      return {
        ...state,
        deleteFetching: false
      }
    }
    case getType(deleteNotificationsActions.failure): {
      return {
        ...state,
        deleteFetching: false,
        deleteError: action.payload.error,
      }
    }
    case getType(getResetNotificationsActions.request): {
      return {
        ...state,
        isReseting: true,
      }
    }
    case getType(getResetNotificationsActions.success): {
      return {
        ...state,
        isReseting: false
      }
    }
    case getType(getResetNotificationsActions.failure): {
      return {
        ...state,
        isReseting: false,
        isResetingError: action.payload.error,
      }
    }
    default: {
      return state;
    }
  }
}
